import { useNavigate } from "@solidjs/router";
import type { EmptyStateProps } from "../components/emptyState/EmptyState";
import EmptyState from "../components/emptyState/EmptyState";
import type { TranslationKey } from "../state/i18n";
import { useTranslation } from "../state/i18n";
import { Title } from "@solidjs/meta";
import { upperFirst } from "lodash-es";

type ResourceNotFoundProps = { resource: TranslationKey } & Pick<EmptyStateProps, "illustration">;

const ResourceNotFoundPage = (props: ResourceNotFoundProps) => {
  const { t } = useTranslation();

  return (
    <main>
      <Title>{t(($) => $.RESOURCE_NOT_FOUND_PAGE_TITLE, { resource: upperFirst(t(props.resource)) })}</Title>
      <div class="mt-20">
        <ResourceNotFoundContent {...props} />
      </div>
    </main>
  );
};

export const ResourceNotFoundContent = (props: ResourceNotFoundProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <EmptyState
      title={t(($) => $.RESOURCE_NOT_FOUND_TITLE, { resource: t(props.resource) })}
      description={t(($) => $.RESOURCE_NOT_FOUND_DESCRIPTION)}
      illustration={props.illustration}
      action={{
        text: t(($) => $.RESOURCE_NOT_FOUND_RETURN_HOME),
        icon: "home",
        onClick: () => navigate("/"),
      }}
    />
  );
};

export default ResourceNotFoundPage;
